const splide = new Splide('.splidec', {
  type: 'slide',
    perPage: 2.5,
    perMove: 1,
    gap: '24px',
    speed: 400,
    easing: 'ease',
    drag: true,
    snap: false,
    pagination: false,
    rewindByDrag: false,
    arrows: false,
    loop:false,
    
      focus: 0,

  breakpoints: {
    768: {
      perPage: 1.5,
      gap: '16px',
    }
  }
});

const bar = document.querySelector('.slider-progress__bar');
const track = document.querySelector('.slider-progress');

function updateProgressBar() {
  const maxIndex = splide.Components.Controller.getEnd();
  const current = splide.index;

  const maxMove = track.clientWidth - bar.clientWidth;

  const progress = maxIndex > 0 ? current / maxIndex : 0;

  bar.style.transform = `translateX(${progress * maxMove}px)`;
}

splide.on('mounted moved resized refreshed', updateProgressBar);

splide.mount();


new Splide('.splidew', {
  type: 'slide',
  perPage: 1.5,
  perMove: 1,
  gap: '16px',
  arrows: false,
  pagination: false,
  drag: true,
  focus: 0,

  breakpoints: {
    768: {
      destroy: false, // Keep active below 768px
    },
    769: {
      destroy: true, // Destroy at 769px and above
    }
  }
}).mount();